import { authGetterType } from '@/vuex-store/auth/getters';
export default function login({ next, store }) {
    // 인증시 루트 페이지로 이동
    const isAuthenticated = store.getters[authGetterType.isAuthenticated];
    if (isAuthenticated) {
        return next({
            path: '/',
        });
    }
    return next();
}
